import { Introduction } from "./Introduction";
import { Points } from "./Points";
import { Casters } from "./Casters";
import { StaffProvider } from "../../context/StaffProvider";
import { RoutePageMeta } from "../../seo/RoutePageMeta";

export const About = () => {
  return (
    <div className="flex w-full flex-col gap-[clamp(3rem,7vw,5rem)] pb-16 max-[600px]:pb-12">
      <RoutePageMeta page="ABOUT" />
      <StaffProvider>
        <Introduction />
        <div className="about-page-shell flex flex-col gap-[clamp(3rem,7vw,5rem)]">
          <Points />
          <Casters />
        </div>
      </StaffProvider>
    </div>
  );
};
